module.exports = "<div class=\"sidebar\">\n  <app-sidebar-menu></app-sidebar-menu>\n  <button class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/layout/sidebar/sidebar.component.html
// module id = ../../../../../src/app/core/components/layout/sidebar/sidebar.component.html
// module chunks = main